import { useEffect, useRef, useState } from 'react';
import { W, H } from '../card/tokens';

/**
 * Shows the card: the PNG once it exists, the live markup scaled to fit until then.
 * `sheet` shows only the white sheet (headline and work), for inside the app,
 * where the card's own header and footer just repeat the screen's.
 */
export function CardView({ html, pngUrl, sheet }: { html?: string; pngUrl?: string | null; sheet?: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  useEffect(() => {
    if (!ref.current) return;
    const ro = new ResizeObserver(([e]) => setScale(e.contentRect.width / W));
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);
  if (pngUrl && sheet) return <div className="sheet-crop lifted"><img src={pngUrl} alt="The card" /></div>;
  if (pngUrl) return <div className="card-preview"><img src={pngUrl} alt="The card" /></div>;
  return (
    <div className="card-scale" ref={ref}>
      <div style={{ width: W, height: H, transform: `scale(${scale})` }} dangerouslySetInnerHTML={{ __html: html || '' }} />
    </div>
  );
}
